import {
  PageMappingType, RuleOperator, type PageMapping, type Page,
} from '@/modules/Pages/declarations/pages';

export function defaultOperatorForType(type: PageMappingType): RuleOperator | undefined {
  if (type === PageMappingType.URL_CONTAINS) return RuleOperator.OR;
  if (type === PageMappingType.REGEX) return RuleOperator.OR;
  return undefined;
}

export function resolveOperatorForMapping(mapping: PageMapping): RuleOperator | undefined {
  if (mapping.type === PageMappingType.REGEX) {
    if (mapping.javascript?.trim()) return RuleOperator.AND;
    return RuleOperator.OR;
  }
  if (mapping.type === PageMappingType.URL_CONTAINS) return mapping.operator ?? RuleOperator.OR;
  return undefined;
}

export function preparePageMappingForPayload(mapping: PageMapping): PageMapping {
  const javascript = mapping.type === PageMappingType.REGEX
    ? (mapping.javascript?.trim() || null)
    : null;

  return {
    ...mapping,
    operator: resolveOperatorForMapping({
      ...mapping,
      javascript,
    }),
    javascript,
  };
}

export function isIndexPage(page: Page) {
  return page.name === 'Index';
}
